// DocumentosPresentados.js — Merge Solponiente
import React, { useEffect, useState } from "react";
import { Table, Button, Card, Spinner, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Components/Header";
import 'bootstrap-icons/font/bootstrap-icons.css';

const BASE_URL = 'https://oficinavirtual-solponiente.com/api';

const DocumentosPresentados = () => {
  const [documentos, setDocumentos] = useState([]);
  const [loadingDocumentos, setLoadingDocumentos] = useState(true);
  const [descargando, setDescargando] = useState(null); // id del doc en descarga
  const userId = localStorage.getItem("id");

  useEffect(() => {
    const fetchDocumentos = async () => {
      setLoadingDocumentos(true);
      try {
        const response = await fetch(
          `${BASE_URL}/documentos/usuario/${userId}`,
          {
            headers: {
              "Cache-Control": "no-cache",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setDocumentos(data);
        } else {
          console.error("Error al obtener documentos");
        }
      } catch (error) {
        console.error("Error al hacer la solicitud:", error);
      } finally {
        setLoadingDocumentos(false);
      }
    };

    fetchDocumentos();
  }, []);

  // Descarga llamando al endpoint dedicado — sin base64 en memoria
  const handleDownload = async (documentoId, nombreDocumento) => {
    setDescargando(documentoId);
    try {
      const response = await fetch(
        `${BASE_URL}/documentos/${documentoId}/download`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (!response.ok) throw new Error("Error al descargar el documento");

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombreDocumento || "documento.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar:", error);
      alert("No se pudo descargar el documento.");
    } finally {
      setDescargando(null);
    }
  };

  return (
    <div className="d-flex flex-column">
      <Header />
      <main className="flex-grow-1">
        <Container fluid className="py-3 px-4">
          <Card
            className="shadow bg-white"
            style={{ borderRadius: "0.75rem", overflow: "hidden" }}
          >
            <Card.Body className="pb-0">
              <h4 className="mb-2 mt-2">
                <i className="bi bi-file-earmark-text me-2 text-primary"></i>
                Documentos presentados
              </h4>
              <p className="text-muted mb-4">
                En esta sección puede consultar y descargar todos los documentos
                que haya presentado a través de la oficina virtual.
              </p>
            </Card.Body>

            {loadingDocumentos ? (
              <Card.Body className="text-center py-5">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </Spinner>
                <p className="mt-3 mb-0">Cargando documentos...</p>
              </Card.Body>
            ) : (
              <Card.Body className="pt-1 p-1">
                {documentos.length === 0 ? (
                  <p className="text-center text-muted py-4">
                    No ha presentado ningún documento.
                  </p>
                ) : (
                  <Table hover responsive className="mb-2 align-middle">
                    <thead>
                      <tr>
                        <th>Nombre de documento</th>
                        <th style={{ width: "220px" }}>Fecha de subida</th>
                        <th className="text-center" style={{ width: "150px" }}>
                          Descarga
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {documentos.map((doc) => (
                        <tr key={doc.DocumentoID}>
                          <td className="text-muted">{doc.NombreDocumento}</td>
                          <td>
                            {new Date(doc.FechaSubida).toLocaleDateString(
                              "es-ES",
                              { year: "numeric", month: "long", day: "numeric" }
                            )}
                          </td>
                          <td className="text-end">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              disabled={descargando === doc.DocumentoID}
                              onClick={() =>
                                handleDownload(doc.DocumentoID, doc.NombreDocumento)
                              }
                            >
                              {descargando === doc.DocumentoID ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <><i className="bi bi-download me-1" />Descargar</>
                              )}
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
            )}
          </Card>
        </Container>
      </main>
    </div>
  );
};

export default DocumentosPresentados;